import React from 'react'
import "./Page3.css"

const Page3 = () => {
  return (
    <div className='page3-main'>
        <div className="page3">
            <h6>We Value Your Ideas</h6>
            <h1>Let's Build An Ideal nation Together!</h1>
            <p>
                RedPhantom goal is to create a generation of young people who are both knowledge and skilled.
                We are enhancing the system of education to focus on practical things eith more abilities. And believes 
                that over 18% of global population are Youth who want to accomplish their creative ideas ans want to complete 
                their goal of getting adequate carrer guidence in order to innovative and employable 
                community and a thriving nation.
            </p>
            <button className='butn'>Discover More</button>
        
        </div>
    </div>
  )
}

export default Page3